import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Ban, CheckCircle2 } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { Loader } from "@/components/common/Loader";
import { PageHeader, StatusBadge } from "@/components/dashboard/ui";

const PLANS = ["starter", "professional", "studio"];

export default function AdminPhotographers() {
  const [list, setList] = useState(null);
  const load = () => api.get("/admin/photographers").then((r) => setList(r.data.photographers)).catch(() => setList([]));
  useEffect(() => { load(); }, []);
  if (!list) return <Loader />;

  const setStatus = async (id, status) => {
    try { await api.post(`/admin/photographers/${id}/status`, { status }); toast.success(`Account ${status}`); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const setPlan = async (id, plan) => {
    try { await api.post(`/admin/photographers/${id}/plan`, { plan }); toast.success("Plan updated"); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div>
      <PageHeader title="Photographers" subtitle={`${list.length} studios on PMR Events`} />
      <div className="rounded-2xl border border-border overflow-hidden overflow-x-auto">
        <div className="min-w-[820px]">
          <div className="grid grid-cols-12 gap-4 px-5 py-3 bg-black/40 text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
            <div className="col-span-3">Studio</div><div className="col-span-2">Email</div><div className="col-span-1">Events</div><div className="col-span-1">Photos</div><div className="col-span-2">Plan</div><div className="col-span-1">Status</div><div className="col-span-2 text-right">Actions</div>
          </div>
          {list.map((p) => (
            <div key={p.id} data-testid={`admin-photographer-${p.id}`} className="grid grid-cols-12 gap-4 px-5 py-4 items-center border-b border-border last:border-0 hover:bg-white/[0.02]">
              <div className="col-span-3">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-gold/15 text-gold flex items-center justify-center text-sm font-medium">{(p.business_name || p.name).charAt(0)}</div>
                  <div className="min-w-0"><div className="text-white text-sm font-medium truncate">{p.business_name || p.name}</div><div className="text-xs text-muted-foreground truncate">{p.name}</div></div>
                </div>
              </div>
              <div className="col-span-2 text-xs text-muted-foreground truncate">{p.email}</div>
              <div className="col-span-1 text-sm text-secondary-foreground">{p.events}</div>
              <div className="col-span-1 text-sm text-secondary-foreground">{p.photos}</div>
              <div className="col-span-2">
                <select data-testid={`plan-select-${p.id}`} value={p.plan} onChange={(e) => setPlan(p.id, e.target.value)} className="bg-secondary border border-input rounded-lg px-2 py-1.5 text-sm text-white capitalize outline-none focus:border-gold">
                  {PLANS.map((pl) => <option key={pl} value={pl}>{pl}</option>)}
                </select>
              </div>
              <div className="col-span-1"><StatusBadge status={p.status} /></div>
              <div className="col-span-2 flex justify-end">
                {p.status === "active" ? (
                  <button data-testid={`suspend-${p.id}`} onClick={() => setStatus(p.id, "suspended")} className="inline-flex items-center gap-1.5 text-xs text-destructive glass rounded-full px-3 py-1.5 hover:bg-destructive/10"><Ban className="w-3.5 h-3.5" /> Suspend</button>
                ) : (
                  <button data-testid={`activate-${p.id}`} onClick={() => setStatus(p.id, "active")} className="inline-flex items-center gap-1.5 text-xs text-emerald-400 glass rounded-full px-3 py-1.5 hover:bg-emerald-400/10"><CheckCircle2 className="w-3.5 h-3.5" /> Activate</button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
